module.exports = "/images/_/_/_/_/build/resources/js/src/assets/images/pages/eCommerce/4.png";